<template>
    <div v-if="IsMoal==true" >
        <b-modal :id="id" hide-footer centered hide-header  v-model="ShowMoal" v-if="type==1" ref="PreviewModal" backdrop="static"   @hide="handleHide">  
            <button class="close" type="button" @click="closeModal()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <div class="modal-body" >
                <div class="Preview-hearder">
                    <div class="Preview-hearder-img"><img :src="cdnURL+'SupperPreviewModal-icon.svg'"/></div>
                    <div class="Preview-hearder-title">{{ $t("lbl_EMPBE_PreviewTitle") }}</div>
                </div>
                <div class="Preview-Body">
                    <div class="Preview-Body-head">{{ $t("lbl_EMPBE_PreviewText") }}</div>
                    <div class="Preview-Body-msg"><img :src="cdnURL+'SupperPreviewModalDone-icon.svg'" />{{ $t("lbl_EMPBE_PreviewMsg") }}</div>
                    <div class="Preview-Body-msg"><img :src="cdnURL+'SupperPreviewModalDone-icon.svg'" />{{ $t("lbl_EMPBE_PreviewMsgs") }}</div>
                    <div class="Preview-Body-link" v-html="$t('lbl_EMPBE_PreviewLink')"></div>
                </div>
                <div class="Preview-Body-footer">
                   <button type="button" class="btn btn-light PreviewModalMsgRevier gotoCompanyView" @click="gotoCompanyView()" t_label="EMP_Preview_preview" data-dismiss="modal">{{ $t("lbl_EMPBE_PreviewReview") }}</button>
                    <button type="button" class="btn btn-primary" @click="ExperienceNow()" t_label="EMP_Preview_ExperienceNow" data-dismiss="modal">{{ $t("lbl_EMPBE_PreviewExperienceNow") }}</button>
                </div>
            </div>
        </b-modal>
        <b-modal :id="id" hide-footer centered  v-model="ShowMoalSeconed" hide-header  backdrop="static"   @hide="handleHide"> 
            <div class="modal-body" >
                <div class="Preview-hearder">
                    <div class="Preview-hearder-img"><img :src="cdnURL+'SupperPreviewOkModal-icon.svg'"/></div>
                    <div class="Preview-hearder-title">{{ $t("lbl_EMPBE_PreviewOkTitle") }}</div>
                </div>
                <div class="Preview-Body">
                    <div class="Preview-Body-head">{{ $t("lbl_EMPBE_PreviewOkText") }}</div>
                    <div class="Preview-Body-msg "><div class="Preview-Body-cearcl"></div><div  class="Preview-Body-Right DialogText">{{ $t("lbl_EMPBE_PreviewOkTextFirst",{endTime:timer}) }}</div></div>
                    <div class="Preview-Body-msg "><div class="Preview-Body-cearcl"></div><div  class="Preview-Body-Right DialogText">{{ $t("lbl_EMPBE_PreviewOkTextSeconed") }}</div></div>
                    <div class="Preview-Body-msg "><div class="Preview-Body-cearcl"></div><div  class="Preview-Body-Right DialogText">{{ $t("lbl_EMPBE_PreviewOkTextThrd") }}</div></div>
                </div>
                <div class="Preview-Body-footer">
                    <a href="javascript:;" class="PreviewModalMsgRevier" @click="CloseSupperPreviewOkModal()"  t_label="EMP_Preview_preview_Ok">{{ $t("lbl_EMPBE_Ok") }}</a>
                </div>
            </div>
        </b-modal>
    </div>
    <div v-else   >
        <b-card no-body class="b-r-3 dashboardCard">
            <b-card-title>
                <div class="mt-4 ml-4 mr-4 f-16 Roboto">
                    <span class="dashboardHeader">{{ $t("lbl_EMPBE_ServerUpdate") }}</span>
                </div>
            </b-card-title>
            <b-card-body body-class="p-y-25" v-if="type==1">
                <div class="Preview-hearder">
                    <div class="Preview-hearder-img"><img :src="cdnURL+'SupperPreviewModal-icon.svg'"/></div>
                    <div class="Preview-hearder-title">{{ $t("lbl_EMPBE_PreviewTitle") }}</div>
                </div>
                <div class="Preview-Body">
                    <div class="Preview-Body-head">{{ $t("lbl_EMPBE_PreviewText") }}</div>
                    <div class="Preview-Body-msg"><img :src="cdnURL+'SupperPreviewModalDone-icon.svg'" />{{ $t("lbl_EMPBE_PreviewMsg") }}</div>
                    <div class="Preview-Body-msg"><img :src="cdnURL+'SupperPreviewModalDone-icon.svg'" />{{ $t("lbl_EMPBE_PreviewMsgs") }}</div>
                    <div class="Preview-Body-link" v-html="$t('lbl_EMPBE_PreviewLink')"></div>
                </div>
                <div class="Preview-Body-footer">
                    <button type="button" class="btn btn-light alwaysEnabled PreviewModalMsgRevier gotoCompanyView" @click="gotoCompanyView()" t_label="EMP_Preview_preview" data-dismiss="modal">{{ $t("lbl_EMPBE_PreviewReview") }}</button>
                    <button type="button" class="btn btn-primary alwaysEnabled" @click="ExperienceNow()" t_label="EMP_Preview_ExperienceNow" data-dismiss="modal">{{ $t("lbl_EMPBE_PreviewExperienceNow") }}</button>
               
                </div>
            </b-card-body>
            <b-card-body body-class="p-y-25" v-if="type==2">
                <div class="Preview-hearder">
                    <div class="Preview-hearder-img"><img :src="cdnURL+'SupperPreviewOkModal-icon.svg'"/></div>
                    <div class="Preview-hearder-title">{{ $t("lbl_EMPBE_PreviewOkTitle") }}</div>
                </div>
                <div class="Preview-Body">
                    <div class="Preview-Body-head">{{ $t("lbl_EMPBE_PreviewOkText") }}</div>
                    <div class="Preview-Body-msg"><div class="Preview-Body-cearcl"></div><div  class="Preview-Body-Right">{{  $t("lbl_EMPBE_PreviewOkTextFirst",{endTime:timer}) }}</div></div>
                    <div class="Preview-Body-msg"><div class="Preview-Body-cearcl"></div><div  class="Preview-Body-Right">{{ $t("lbl_EMPBE_PreviewOkTextSeconed") }}</div></div>
                    <div class="Preview-Body-msg"><div class="Preview-Body-cearcl"></div><div  class="Preview-Body-Right">{{ $t("lbl_EMPBE_PreviewOkTextThrd") }}</div></div>
                </div>
                <div class="Preview-Body-footer">
                    <a href="javascript:;" class="PreviewModalMsgRevierRed" @click="RebackSupperPreviewOkModal()"  t_label="EMP_Preview_BeforeTime">{{ $t("lbl_EMPBE_BeforeTime",{timer:timer}) }}</a>
                </div>
            </b-card-body>
            <b-card-body body-class="p-y-25" v-if="type==3">
                <div class="Preview-hearder">
                    <div class="Preview-hearder-img"><img :src="cdnURL+'SupperPreviewUpdateSucess.svg'"/></div>
                    <div class="Preview-hearder-title">{{ $t("lbl_EMPBE_PreviewUpdateSuccess") }}</div>
                </div>
                <div class="Preview-Body">
                    <div class="Preview-Body-head">{{ $t("lbl_EMPBE_PreviewOkText") }}</div>
                    <div class="Preview-Body-msg"><div class="Preview-Body-cearcl"></div><div  class="Preview-Body-Right">{{ $t("lbl_EMPBE_PreviewOkTextSeconed") }}</div></div>
                    <div class="Preview-Body-msg"><div class="Preview-Body-cearcl"></div><div  class="Preview-Body-Right">{{ $t("lbl_EMPBE_PreviewOkTextThrd") }}</div></div>
                </div>
            </b-card-body>
         </b-card>
    </div>
    

</template>


<script>

import { CompanyInfoService } from "@/_services";
export default {
    props: ["IsMoal","ShowMoal","id" , "simulatedSupplier"],//type 
    data() {
        return {
            cdnURL:"https://cdn.adsalecdn.com/EMP/2-0/images/",
            type:0,
            timer:"",
            thendata:{},
            ShowMoalSeconed:false,
            ExpirationDate:undefined
        }
    },
    created(){
        
        this.GetAIPreviewHeader();
    },
    
  computed: {
    actionuser(){
        return this.$store.state.authentication.user

    },
    user() {
        return this.simulatedSupplier ? this.simulatedSupplier : this.$store.state.authentication.user
    
      //return this.$store.state.authentication.user
    },
        ReportLang()
        {
          switch (localStorage.getItem("currentLangId")) {
                case "1252":
                return "eng";
                case "950":
                return "trad";
                case "936":
                return "simp";
                default:
                return "eng";
            }
        },
    endTime(){

        return this.timer;
    },
    
    },
    methods: {
        handleHide(bvEvent) {
            // 判断是否是点击背景触发的关闭
            if (bvEvent.trigger === 'backdrop') {
                // 取消关闭操作
                bvEvent.preventDefault();
            }
        },
        closeModal()
        {
            this.$refs.PreviewModal.hide();  
        },
        RebackSupperPreviewOkModal()
        {
            this.UpdateStrus("CLICK_CACEL","").then(res=>{
                this.GetAIPreviewHeader();
            })
        },
        CloseSupperPreviewOkModal()
        {
            this.$emit('changedilog');
            this.ShowMoalSeconed=false;
        }       
        ,
        GetAIPreviewHeader(){
            CompanyInfoService.GetAIPreviewHeader(this.user.empCompanyId).then(res=>{
                this.thendata = res.data[0]
                if(!this.thendata)
                {
                    this.CloseAllMethods();
                    return;
                }
                var thenDate =new Date();
                var date = new Date(this.thendata.confirmDate);
                date.setDate(date.getDate() + 7);
                
                
                if(!this.thendata.isConfirmConsent && this.thendata.status=="PREVIEW")
                {
                    this.type=1
                }else if(this.thendata.isConfirmConsent && this.thendata.status=="PREVIEW")
                {
                    this.type=2;
                    this.GetDiffLangDate(this.thendata.confirmDate)
                    if(this.ExpirationDate < thenDate)
                    {
                        this.CloseAllMethods();
                    }
                }
                else if (this.thendata.isConfirmConsent && this.thendata.status=="DONE" &&  date > thenDate)
                {
                    this.type=3;
                }else
                {
                    this.CloseAllMethods();
                }
                
            })
            
        },
        CloseAllMethods(){
            this.$emit("closeAll")
        },
        GetDiffLangDate(timers)
        {
            if (!timers) return "";

            const date = new Date(timers);
            
            
           this.timer =  this.getHoursAndMinutesAfterMinutes(15,date);
        },
        getHoursAndMinutesAfterMinutes(Min,date) 
        {


            this.ExpirationDate = date.setMinutes(date.getMinutes() + Min);

            let hours = date.getHours();

            let minutes = date.getMinutes();

            minutes = minutes.toString().padStart(2, '0');

            return `${hours}:${minutes}`;
        },
        ExperienceNow(){
            this.UpdateStrus("CLICK_CONSENT","").then(res=>{
                this.GetAIPreviewHeader();
                this.ShowMoalSeconed=true;
            })
        },
        UpdateStrus(logsName,url){
            //var Actionname =this.actionuser.companyNameTc != "" ? this.user.companyNameTc : this.user.companyNameSc != "" ? this.user.companyNameSc : this.user.companyNameEn;
            var Actionname = this.actionuser.empCompanyId;
            return new Promise((resolve, reject) => {
                CompanyInfoService.UpdatePrivewStrus({CompanyId: this.user.empCompanyId, HeaderPreviewCode: this.thendata.headerPreviewCode, LogName: logsName, Ip: "", Url: url, Referrer:location.href,  ActionBy:Actionname}).then(res=>{

                 resolve(res.data[0]);
                })
            });
       
            
        },
        gotoComanyViewHref(){
            var ReportUrl = `${process.env.VUE_APP_EMP_VIEW}ExhibitorInfo/`+this.ReportLang+"?compid="+this.user.empCompanyId+"&AIPreview=true";
            return ReportUrl;
        },
        gotoCompanyView(){
            
            var ReportUrl = this.gotoComanyViewHref();
            this.UpdateStrus("CLICK_PREVIEW",ReportUrl);
            this.ShowMoal=false;
            window.open(ReportUrl, '_blank');
        }
    }
}
</script>

<style lang="scss" scoped>
.gotoCompanyView{
    background-color: #fff !important;
    border: none;
}
::v-deep .modal-backdrop {
    opacity: 0.1 !important;
}
.Preview-Body-Right
{
    margin-left: 22px;
}
.Preview-Body-cearcl
{
    width: 5px;
    height: 5px;
    background-color: #000;
    border-radius: 50%;
        margin-right: 10px;
        position: absolute;
        top: 8px;
        left: 8px;
}
 ::v-deep .modal-content
{
    border: none;
    border-radius: 16px !important;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
}
 .modal-dialog .modal-body {
    padding: 24px;
}
    .PreviewModalMsgRevier {
        margin-right: 16px;
        color: #000;
    }
    .PreviewModalMsgRevierRed {
        margin-right: 16px;
        color:red;
    }
.Preview-Body-footer
{
    text-align: right;
    margin-top: 16px;
}
.Preview-hearder{
    text-align: center;
}
.Preview-hearder-title
{
    margin-top: 16px;
    color: #000c;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 36px */
    letter-spacing: -0.264px;
}
.DialogText{
    color: #000c;
}
.Preview-Body{
    margin-top: 16px;
}
.Preview-Body-head
{
    
    margin-bottom: 16px;
    color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
font-feature-settings: 'liga' off, 'clig' off;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 150%; /* 21px */
}
.Preview-Body-msg
{
    
    margin-bottom: 16px;
    color: rgba(0, 0, 0, 0.50);

    font-feature-settings: 'liga' off, 'clig' off;
    /* Text/Paragraph 2 */
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
    letter-spacing: 0.15px;
    position: relative;
}
.Preview-Body-msg img
{
    margin-right: 8px;
}
.Preview-Body-link
{
    color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
    font-feature-settings: 'liga' off, 'clig' off;
    /* Text/Paragraph 3 */
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 18px */
}
.Preview-Body-link a
{
    text-decoration: underline !important;
    color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
}
.close{
    right: 10px;
    top: 10px;
    position: relative;
    z-index: 1;
}
.dashboardCard {
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, .25) !important;
    border-radius: 16px !important;
}

</style>
